import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEllipsis = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.84 6.35a1.741 1.741 0 1 0 0 3.482 1.741 1.741 0 0 0 0-3.482m-6.098 0a1.742 1.742 0 1 0 0 3.483 1.742 1.742 0 0 0 0-3.483m12.196 0a1.741 1.741 0 1 0 0 3.482 1.741 1.741 0 0 0 0-3.482"
      />
    </svg>
  );
};
export default SvgEllipsis;
